import React from "react";
import { Autocomplete, TextField, TextFieldProps } from "@mui/material";
import { COUNTRY_OPTIONS } from "../../utils/countryUtils";

interface CountrySelectProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  error?: boolean;
  helperText?: React.ReactNode;
  required?: boolean;
  size?: TextFieldProps["size"];
  disabled?: boolean;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  onChange,
  label = "Country",
  error,
  helperText,
  required,
  size = "small",
  disabled = false,
}) => {
  return (
    <Autocomplete
      options={COUNTRY_OPTIONS}
      getOptionLabel={(option) => option.label}
      value={COUNTRY_OPTIONS.find((opt) => opt.value === value) || null}
      onChange={(_, newValue) => {
        onChange(newValue ? newValue.value : "");
      }}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={error}
          helperText={helperText}
          required={required}
          size={size}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
        />
      )}
    />
  );
};
